export default function AsyncBoundary({
  status,
  error,
  retry,
  isEmpty = false,
  emptyMessage = '',
  children,
}) {
  if (status === 'loading') {
    return (
      <div className="admin-async-skeleton" role="status" aria-live="polite">
        <span className="admin-async-sr-only">در حال بارگذاری اطلاعات…</span>
        <span className="admin-async-skeleton-line" aria-hidden="true" />
        <span className="admin-async-skeleton-line" aria-hidden="true" />
        <span className="admin-async-skeleton-line" aria-hidden="true" />
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="admin-async-error" role="alert">
        <div className="admin-status is-rejected">
          <span>{error?.message}</span>
          <span className="admin-async-code" dir="ltr">{error?.code}</span>
        </div>
        <button type="button" className="btn-reject" onClick={retry}>تلاش دوباره</button>
      </div>
    );
  }

  if (isEmpty) return <div className="admin-empty">{emptyMessage}</div>;
  return children;
}
